// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3BgT-","author":"Table_author__1O58q","authorImage":"Table_authorImage__2FcIs","unreadRow":"Table_unreadRow__17ik4"};